export default [
  'save_dashboard',
  'save_collector',
  'save_mobile',
  'save_ussd',
  'save_api',
  'save_cron',
];
